// Access videojs from global (same pattern as other plugins in codebase)
// eslint-disable-next-line no-undef
const Component = videojs.getComponent('Component')

export const COMPONENT_NAME = 'OracleGuideOnSideComponent'

/**
 * video.js Component that hosts the React GotS panel.
 *
 * This is a simple component class with just createEl() - all React mounting
 * is handled in the plugin function (following the video-player-app pattern).
 *
 * Being a video.js Component inside the player DOM means:
 * 1. User interactions automatically report activity (no 500ms interval needed)
 * 2. Z-index is relative to player, not page (fixes z-index conflicts)
 * 3. Visibility controlled by vjs-user-active / vjs-user-inactive CSS classes
 * 4. Proper lifecycle management (dispose on player dispose)
 */
class OracleGuideOnSideComponentClass extends Component {
  /**
   * Create the DOM element for this component.
   * Uses vjs- prefix for proper video.js styling integration.
   */
  // eslint-disable-next-line class-methods-use-this
  createEl () {
    // eslint-disable-next-line no-undef
    return videojs.dom.createEl('div', {
      className: 'vjs-oracle-guide-on-side',
    })
  }
}

// Export the class for registration
export const OracleGuideOnSideComponent = OracleGuideOnSideComponentClass
